import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import LogoInnerImg from "../images/logo-inner.svg";

const SupportHeader = () => {
  const [showMenu, setShowMenu] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleLogout = () => {
    localStorage.removeItem("supporthcpId");
    localStorage.removeItem("supporthcpToken");
    localStorage.removeItem("supporthcpEmail");
  };

  return (
    <>
      <header className="inner fixed-top">
        <nav className="navbar navbar-expand-lg bg-white">
          <section className="container">
            <div className="navigation d-flex align-items-end w-100">
              <button
                className="navbar-toggler"
                type="button"
                onClick={toggleMenu}
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className={`offcanvas offcanvas-start border-end-0 ${
                  showMenu ? "show" : "hide"
                }`}
                tabIndex="-1"
              >
                <div className="offcanvas-header d-flex d-lg-none">
                  <img src={LogoInnerImg} className="img-fluid w-75" alt="" />

                  <button
                    type="button"
                    className="btn-close"
                    onClick={toggleMenu}
                  ></button>
                </div>
                <div className="offcanvas-body">
                  <ul className="navbar-nav mb-lg-0">
                    <li className="nav-item">
                      <Link
                        className={`nav-link ${
                          location.pathname === "/support-hcp-enrol"
                            ? "active-blue"
                            : ""
                        }`}
                        aria-current="page"
                        to="/support-hcp-enrol"
                      >
                        ENROL PATIENT
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className={`nav-link ${
                          location.pathname === "/support-hcp-program"
                            ? "active-blue"
                            : ""
                        }`}
                        aria-current="page"
                        to="/support-hcp-program"
                      >
                        PROGRAM
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className={`nav-link ${
                          location.pathname === "/support-hcp-product"
                            ? "active-blue"
                            : ""
                        }`}
                        aria-current="page"
                        to="/support-hcp-product"
                      >
                        Product
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className={`nav-link ${
                          location.pathname === "/support-hcp-details"
                            ? "active-blue"
                            : ""
                        }`}
                        aria-current="page"
                        to="/support-hcp-details"
                      >
                        My details
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/" onClick={handleLogout}>
                        Logout
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <Link to="/co-pay-hcp-enrol" className="w-50 logo-inner ms-auto">
                <img src={LogoInnerImg} className="img-fluid" alt="" />
              </Link>
            </div>
          </section>
        </nav>
      </header>
    </>
  );
};
export default SupportHeader;
